import { Routes } from '@angular/router';
import { AuthGuard } from '@core/services/auth-guard.service';
import { CurrentProjectGuard } from '../../projects/services/current-project-guard';
import { StreamsContentComponent } from './components/streams-content/streams-content.component';
import { StreamsToolbarComponent } from './components/streams-toolbar/streams-toolbar.component';


export const streamsRoutes: Routes = [
  {
    path      : 'cr/settings/streams',
    component: StreamsContentComponent
  },
  {
    path      : 'footprint/streams',
    component: StreamsContentComponent
  },
  {
    path     : 'streams-toolbar',
    component: StreamsToolbarComponent,
    outlet   : 'top-toolbar',
    canActivate: [AuthGuard, CurrentProjectGuard]
  }
];
